<template>
    <div v-for="item in sortedProducts" :key="item" class="transition lg:mr-4 mb-4 ease-in-out delay-150 col-span-1 shadow-2xl"
            :disabled="item.price >= $page.props.user.play_tokens"
    >
        <div class="rounded-lg shadow bg-gray-900 w-full lg:w-80">
            <div class="flex border-2 border-gray-200 border-opacity-10 rounded-lg w-full p-2">
                <div class="flex ml-3">
                    <img class="w-40 my-auto" :src="`storage/${item.picture}`"/>
                </div>

                <div class="flex flex-col w-full ml-3 p-2">
                    <span class="w-full flex font-bold text-white text-left">
                        <p class="text-md sm:text-lg sm:h-fit mb-0 line-clamp-2">{{item.name}}</p>
                    </span>

                    <span class="flex pt-[6px]">
                        <p class="inline box-shadow-sm text-white text-md sm:text-xl">{{item.price}}</p>
                        <img class="inline w-[22px] my-auto stroke-2 ml-2" src="images/coin-and-tokens/tokens-optimised.svg" />
                    </span>

                    <p  class="py-1 text-md sm:text-lg w-26 sm:w-fit text-left h-fit sm:h-fit mb-0 leading-tight text-white rounded-full mt-2 sm:mt-0">Stock: {{item.quantity}}</p>

                    <Popper @click.stop placement="top" arrow="true" style="--popper-theme-background-color:#19212b;--popper-theme-background-color-hover:#19212b;margin: 0px;border: 0px;margin-bottom: 5px;" class="cursor-pointer">
                        <div class="flex mb-1 mt-1 sm:mt-0">
                            <InformationCircleIcon class="text-slate-500 h-5 w-5 mr-1 my-1"/>
                            <p class="font-medium text-base text-slate-500 my-auto">Description</p>
                        </div>
                        <template #content>
                            <div class="flex flex-col bg-[#19212b] my-2 rounded-b text-xs text-white w-full sm:w-96">
                                {{ item.info || 'No description found.' }}
                            </div>
                        </template>
                    </Popper>

                    <button  @click="productConfirmationModal(item.id)" :disabled="item.price >= $page.props.user.play_tokens"
                            class="shadow-xl font-bold rounded-md p-1 w-full bg-racing-stars-yellow text-black mb-3 hover:bg-yellow-400"
                        >
                        Purchase
                    </button>
                </div>
            </div>
        </div>
    </div>

    <jet-primary-confirmation-modal extraClass="z-50 relative" :show="isConfirmationProductModal">
        <template #title>
            Buy Product
        </template>
        <template #content>
            Are you sure you would like to purchase this product?
        </template>
        <template #footer>
            <jet-secondary-button @click="isConfirmationProductModal = false">
                Cancel
            </jet-secondary-button>
            <jet-primary-button class="ml-2" @click="buyProduct(selectedProduct)" >
                Confirm
            </jet-primary-button>
        </template>
    </jet-primary-confirmation-modal>

    <div v-if="isEmpty(productsData)" class="w-full">
        <div class="text-base text-white font-medium w-full">
            We're out of stock for now, check back at a later date for our limited products!
        </div>
    </div>
</template>

<script>
    import { ref, getCurrentInstance, onMounted, watch, computed, reactive, setTransitionHooks, watchEffect } from 'vue'
    import debounce from 'debounce';
    import JetPrimaryConfirmationModal from '@/Jetstream/PrimaryConfirmationModal.vue'
    import JetPrimaryButton from '@/Jetstream/PrimaryButton.vue'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'
    import { InformationCircleIcon } from '@heroicons/vue/solid'
    import Popper from 'vue3-popper'



    export default {
        props: {
            user: {
                type: Object,
                default: {}
            },
            products: {
                type: Array,
                default: []
            }
        },

        components:{
            JetPrimaryConfirmationModal,
            JetPrimaryButton,
            JetSecondaryButton,
            InformationCircleIcon,
            Popper
        },

        emits: ['getAllProduct'],

        setup(props, { emit }) {
            const windowWidth = ref(window.innerWidth)
            const isConfirmationProductModal = ref(false)
            const selectedProduct = ref(null)

            const setWindowDimensions = () => {
                windowWidth.value = window.innerWidth
            }

            const productsData = ref([])

            const buyProduct = (id) => {
                axios.post(route('api.products.exchange'), {
                    'id': id,
                }).then(response => {
                    isConfirmationProductModal.value = false;
                    if (response.data.success == true) {
                        emit('getAllProduct')
                    }
                });
            }

            const sortedProducts = computed(() => {
                return productsData.value.slice().sort((a, b) => a.price - b.price);
            });

            const productConfirmationModal = (name) => {
                selectedProduct.value = name;
                isConfirmationProductModal.value = true;
            }

            const updateProductData = debounce(() => {
                productsData.value = props.products
            }, 1000);

            const getProductData = () => {
                updateProductData()
            }

            watchEffect(() => {
                if (props.products) {
                    productsData.value = props.products
                }
            })

            onMounted(() => {
                setWindowDimensions()

                getProductData()

                window.addEventListener('resize', setWindowDimensions)
            })

            return {
                productsData,
                buyProduct,
                isConfirmationProductModal,
                selectedProduct,
                productConfirmationModal,
                sortedProducts,
            }
        }
    };
</script>

<style scoped>
    .bg-store-product{
        background-color: #6e647a !important;
    }
    .img-width{
        width: 100%;
        height: 119px;
        object-fit: cover;
        border-radius: 9px;
    }
</style>
